"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRenderPropValue = void 0;
var getRenderPropValue = function getRenderPropValue(propValue) {
  if (!propValue) {
    return null;
  }
  if (typeof propValue === 'function') {
    return propValue();
  }
  return propValue;
};
exports.getRenderPropValue = getRenderPropValue;


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/_util/getRenderPropValue.js
// module id = 425
// module chunks = 0